import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import { RootState } from '../reducers';
import { User } from '../../config/commonTypes';
import * as action from '../actions/user';
import { GoogleLoginResponse } from 'react-google-login';
import { identifyUser } from '../../helpers';
import { logoutUser } from '../actions';

export const useUserState = () => {
  return useSelector((state: RootState) => state.user) as User;
};

export const useUserDispatch = () => {
  const dispatch = useDispatch();
  return {
    ...bindActionCreators({ ...action, }, dispatch),
    replaceSuccessLoginGoogleUser: (response: GoogleLoginResponse) => {
      const user = identifyUser(response);
      dispatch(action.replaceUser(user));
    },
    logoutUser: () => () => dispatch(logoutUser())
  };
};